import { useCallback, useState } from "react";

export type PaymentProvider = "stripe" | "xsolla";

// Geo-based provider routing was removed: an unauthenticated, cacheable
// /payment/v1/provider lookup could pin one viewer's CloudFront-Viewer-Country
// onto every cached response, mis-routing non-RU users into the Xsolla flow.
// Default to Stripe; honor an explicit ?provider= override for manual testing.
const readQueryOverride = (): PaymentProvider | null => {
  if (typeof window === "undefined") return null;
  const raw = new URLSearchParams(window.location.search)
    .get("provider")
    ?.toLowerCase();
  return raw === "stripe" || raw === "xsolla" ? raw : null;
};

export const useResolvedPaymentProvider = () => {
  const [provider] = useState<PaymentProvider>(
    () => readQueryOverride() ?? "stripe",
  );

  const resolve = useCallback(
    async (): Promise<PaymentProvider> => provider,
    [provider],
  );

  return { provider, resolve };
};
